import { transparentize } from "polished";
import styled, { css, DefaultTheme } from "styled-components";

import { SIMPLE_TIMELINE_POINT_SIZE, SimpleTimeLineStatus } from "./SimpleTimeline.utils";

const getPointColor = (theme: DefaultTheme, status: SimpleTimeLineStatus): string => {
    switch (status) {
        case SimpleTimeLineStatus.History:
            return transparentize(0.5, theme.C_ACT_main);
        case SimpleTimeLineStatus.Current:
            return theme.C_ACT_main;
        case SimpleTimeLineStatus.Future:
            return "transparent";
    }
};

const getPointBorderColor = (theme: DefaultTheme, status: SimpleTimeLineStatus): string => {
    switch (status) {
        case SimpleTimeLineStatus.History:
            return "transparent";
        case SimpleTimeLineStatus.Current:
            return theme.C_ACT_main;
        case SimpleTimeLineStatus.Future:
            return theme.C_ACT_main;
    }
};

interface IPoint {
    status?: SimpleTimeLineStatus;
    isFirst?: boolean;
    isLast?: boolean;
    isNextFuture?: boolean;
    topOffset?: string;
    bottomLineOverflow?: string;
}

const LineStyles = css<IPoint>`
    content: "";
    position: absolute;
    width: 2px;
    background-color: ${props => props.status === SimpleTimeLineStatus.Future ? props.theme.C_ACT_main : transparentize(0.5, props.theme.C_ACT_main)};
    border: none;
`;

const DashedLineStyles = css<IPoint>`
    content: "";
    display: block;
    width: 2px;
    background: repeating-linear-gradient(
        to bottom,
        ${props => props.theme.C_ACT_main} 0,
        ${props => props.theme.C_ACT_main} 6px,
        transparent 6px,
        transparent 10px
    );
}`;

const BottomLineStyles = css<IPoint>`
    ${LineStyles};
    top: calc(${props => props.topOffset} + ${SIMPLE_TIMELINE_POINT_SIZE / 2}px);
    height: calc(100% - ${SIMPLE_TIMELINE_POINT_SIZE}px + ${props => props.bottomLineOverflow});
    ${props => props.isNextFuture && DashedLineStyles};
    ${props => !props.isNextFuture && css<IPoint>`
        background-color: ${props => transparentize(0.5, props.theme.C_ACT_main)};
    `};
`;

export const StyledSimpleTimelineItem = styled.div<IPoint>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    
    ${props => !props.isLast && css<IPoint>`
        &:after {
            ${BottomLineStyles};
        }
    `};
`;


export const SimpleTimeLinePoint = styled.div<IPoint>`
    position: relative;
    width: ${SIMPLE_TIMELINE_POINT_SIZE}px;
    height: ${SIMPLE_TIMELINE_POINT_SIZE}px;
    border-radius: 50%;
    background-color: ${props => getPointColor(props.theme, props.status)};
    border: 1px solid ${props => getPointBorderColor(props.theme, props.status)};
    top: calc(${props => props.topOffset} - ${SIMPLE_TIMELINE_POINT_SIZE / 2}px);
`;

export const StyledSimpleTimeline = styled.div`
    display: flex;
    flex-direction: column;

    & ${StyledSimpleTimelineItem} {
        height: 50px;
    }
`;